import IntelliProveAPIError from '~services/errors/intelliprove_api_exception';
import { iErrorEvent, iErrorEventHandler } from './emitter';
import { NavigateFunction } from 'react-router';

export class ErrorNavigator implements iErrorEventHandler {
  navigate: NavigateFunction;

  constructor(navigate: NavigateFunction) {
    this.navigate = navigate;
  }

  handle(event: iErrorEvent): void {
    if (event.error instanceof IntelliProveAPIError) {
      if ([400, 404, 422].includes(event.error.status_code)) return;
    }
    this.navigate('/error', { state: { error: event.error } });
  }
}
